<template>
  <div class="invite_box">
    <div class="list_title" style="margin-bottom: 10px; margin-top: 0">
      邀请名单
    </div>
    <div class="table_box">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-table
          :data="ruleForm.inviteUserInfo"
          border
          :header-cell-style="{
            background: '#FAFAFA',
            color: '#333',
            padding: '12px 0',
          }"
        >
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column label="企业名称" align="center">
            <template slot-scope="scope">
              <el-form-item
                :prop="
                  'inviteUserInfo.' + scope.$index + '.beInviteCompanyName'
                "
                :rules="rules.beInviteCompanyName"
              >
                <el-input
                  maxlength="50"
                  minlength="2"
                  v-model.trim="scope.row.beInviteCompanyName"
                  placeholder="请输入企业名称"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="联系人" align="center">
            <template slot-scope="scope">
              <el-form-item
                :prop="'inviteUserInfo.' + scope.$index + '.beInviteContacts'"
                :rules="rules.beInviteContacts"
              >
                <el-input
                  maxlength="25"
                  minlength="2"
                  v-model.trim="scope.row.beInviteContacts"
                  placeholder="请输入联系人姓名"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" align="center">
            <template slot-scope="scope">
              <el-form-item
                :prop="
                  'inviteUserInfo.' + scope.$index + '.beInviteContactsPhone'
                "
                :rules="rules.beInviteContactsPhone"
              >
                <el-input
                  maxlength="11"
                  v-model="scope.row.beInviteContactsPhone"
                  placeholder="请输入联系人手机号"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="color: #e1251b"
                v-if="ruleForm.inviteUserInfo.length > 1"
                @click="delFun(scope.$index)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div class="addBtn">
        <img src="../img/add.png" alt="">
        <el-button
          style="
            width: 100%;
            border-top: 0px;
            color: #b79255 !important;
            border-radius: 0;
          "
          @click="add"
          >添加</el-button
        >
      </div>
    </div>
    <div class="list_title" style="margin-bottom: 10px; margin-top: 0">
      邀请信息
    </div>
    <div class="title_info">我们将下发邀请短信至联系人手机号</div>
    <div class="title_top">推荐文案</div>
    <div>
      <el-radio-group v-model="ruleForm.msgTemplate" class="invite_radio">
        <el-radio
          :label="index"
          v-for="(item, index) in companyRadioList"
          :key="item.label"
          >{{ item.value }}</el-radio
        >
      </el-radio-group>
    </div>
    <div class="title_top">短信预览</div>
    <div class="title_info">
      <i class="el-icon-question"></i>
      以第一个邀请对象为例，预览邀请短信内容
    </div>
    <div
      class="title_message"
      v-if="
        this.ruleForm.inviteUserInfo.length > 0 &&
        (this.ruleForm.inviteUserInfo[0].beInviteCompanyName !== '' ||
          this.ruleForm.inviteUserInfo[0].beInviteContacts !== '')
      "
    >
      {{ infoTitle }}
    </div>
  </div>
</template>

<script>
import apiInviteJoin from "../api";
export default {
  name: "InvitedComponet",
  data() {
    let validPhone = async (rule, value, callback) => {
      const reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (!value) {
        callback(new Error("请输入联系电话"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号码格式"));
      } else {
        let { data: res } = await apiInviteJoin.getUserByPhone(value);
        if (res.code == 200) {
          this.isRegister = res.data;
        }
        if (this.isRegister) {
          callback(new Error("该手机号已注册"));
        } else {
          callback();
        }
      }
    };
    let validCompanyName = (rule, value, callback, index) => {
      let idx = Number(Object.keys(index).join("").match(/\d+/g));
      let str = this.ruleForm.inviteUserInfo[idx].beInviteContacts;
      let no = this.ruleForm.msgTemplate;
      this.getTemplateTitle(no);
      if (str) {
        callback();
      } else {
        if (!value) {
          callback(new Error("企业名称与联系人至少填写一项"));
        } else {
          this.$refs.ruleForm.clearValidate(
            `inviteUserInfo.${idx}.beInviteContacts`
          );
          callback();
        }
      }
    };

    let validContacts = (rule, value, callback, index) => {
      let idx = Number(Object.keys(index).join("").match(/\d+/g));
      let str = this.ruleForm.inviteUserInfo[idx].beInviteCompanyName;
      let no = this.ruleForm.msgTemplate;
      this.getTemplateTitle(no);
      if (str) {
        callback();
      } else {
        if (!value) {
          callback(new Error("企业名称与联系人至少填写一项"));
        } else {
          this.$refs.ruleForm.clearValidate(
            `inviteUserInfo.${idx}.beInviteCompanyName`
          );
          callback();
        }
      }
    };
    return {
      isRegister: false, //该号码是否已注册
      companyRadioList: [], //短信模板列表
      ruleForm: {
        inviteUserInfo: [
          {
            beInviteCompanyName: "",
            beInviteContacts: "",
            beInviteContactsPhone: "",
          },
        ],
        msgTemplate: 0,
      },
      msgTemplateTitle: "",
      rules: {
        beInviteCompanyName: [
          {
            required: true,
            validator: validCompanyName,
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "企业名称最多可输入20字",
            trigger: "blur",
          },
        ],
        beInviteContacts: [
          { required: true, validator: validContacts, trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "联系人最多可输入20字",
            trigger: "blur",
          },
        ],
        beInviteContactsPhone: [
          {
            required: true,
            trigger: "blur",
            validator: validPhone,
          },
          {
            min: 11,
            max: 11,
            message: "请输入正确的11位手机号码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    dataList: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    infoTitle() {
      if (
        this.ruleForm.inviteUserInfo[0].beInviteCompanyName != "" &&
        this.ruleForm.inviteUserInfo[0].beInviteContacts == ""
      ) {
        return `尊敬的${this.ruleForm.inviteUserInfo[0].beInviteCompanyName}${this.msgTemplateTitle}`;
      } else if (
        this.ruleForm.inviteUserInfo[0].beInviteCompanyName == "" &&
        this.ruleForm.inviteUserInfo[0].beInviteContacts !== ""
      ) {
        return `尊敬的${this.ruleForm.inviteUserInfo[0].beInviteContacts}${this.msgTemplateTitle}`;
      } else {
        return `尊敬的${this.ruleForm.inviteUserInfo[0].beInviteCompanyName}-${this.ruleForm.inviteUserInfo[0].beInviteContacts}${this.msgTemplateTitle}`;
      }
    },
  },
  methods: {
    add() {
      if (this.ruleForm.inviteUserInfo.length >= 10) {
        return this.$message.warning("最多可添加10条");
      }
      let formObj = {
        beInviteCompanyName: "",
        beInviteContacts: "",
        beInviteContactsPhone: "",
      };
      this.ruleForm.inviteUserInfo.push(formObj);
    },
    delFun(index) {
      this.ruleForm.inviteUserInfo.splice(index, 1);
    },
    async getSmsTemplate() {
      if (JSON.stringify(this.dataList) !== "{}") {
        //反显再次邀请
        this.ruleForm.inviteUserInfo[0] = this.dataList;
      }
      let { data: res } = await apiInviteJoin.getSmsTemplate();
      this.companyRadioList = res.result;
      let no = this.ruleForm.msgTemplate;
      this.getTemplateTitle(no);
    },
    getTemplateTitle(val) {
      this.companyRadioList.forEach((item) => {
        let id = Number(item.code) - 1;
        if (id == val) {
          this.msgTemplateTitle = item.value;
        }
      });
    },
    // 校验数据
    validateForm() {
      if (!this.ruleForm.inviteUserInfo.length) {
        this.$message.error("请至少添加一条数据再提交");
      }
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return;
        this.$parent.$parent.submitInvitedLoading = true;
        this.ruleForm.msgTemplate = this.ruleForm.msgTemplate + 1;
        let { data: res } = await apiInviteJoin.inviteNonWebClient(
          this.ruleForm
        );
        if (res.code == 0) {
          this.$message.success("提交成功");
          setTimeout(() => {
            this.$parent.$parent.handleClose();
            this.$parent.$parent.submitInvitedLoading = false;
            this.$refs.ruleForm.resetFields();
          }, 200);
        } else {
          this.$parent.$parent.submitInvitedLoading = false;
          this.$message.error("提交失败，请重试");
        }
      });
    },
  },
  mounted() {
    this.getSmsTemplate();
  },
};
</script>

<style lang="scss" scoped>
.invite_box {
  .list_title {
    margin: 20px 0;
    padding: 0 0 10px 10px;
    color: #b79255;
    font-size: 18px;
    line-height: 24px;
    position: relative;
    font-size: 18px;
    font-family: Microsoft YaHei;
    border-bottom: 1px dashed #e4e7ed;
  }
  .title_info {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #969696;
    margin-bottom: 20px;
  }
  .title_top {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
    margin-bottom: 10px;
  }
  .title_message {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #666666;
    margin-bottom: 20px;
  }

  .list_title::after {
    content: "";
    width: 3px;
    height: 20px;
    background: #b79255;
    position: absolute;
    left: 0;
    top: 2px;
  }
  .invite_radio {
    // overflow: hidden;
    word-break: break-all;
    width: 100%;
    margin-bottom: 20px;
    ::v-deep .el-radio {
      .el-radio__label {
        line-height: 20px;
        color: #666666;
      }
      width: 668px;
      margin-top: 5px;
      padding: 5px 0 5px 5px;
      white-space: normal;
    }
  }
  .table_box {
    .addBtn {
      margin-bottom: 10px;
      margin-top: -10px;
      position: relative;
      img {
          width: 19px;
          height: 19px;
          margin-right: 10px;
          position: absolute;
          top: 24%;
          left: 46%;
        }
    }
    /deep/.el-form-item {
      margin-bottom: 0px;
      .el-form-item__content .el-form-item__error {
        position: relative;
        display: flex;
        padding-top: 0;
      }
    }
    /deep/.el-table .el-table__cell {
      padding: 2px 0px;
    }
  }
  .el-table {
    margin: 10px 0;
    border: 1px solid #e4e7ed;
    border-bottom: 0;
    color: #666;
  }
}
</style>